module.exports = __webpack_public_path__ + "static/img/icon-mine-dropdown.f3bd54f5.png";